// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import L from "leaflet"
// klaro


declare global {
  interface Window {
    // @ts-ignore
    klaro: any;
    klaroConfig: any;
  }
}

import * as klaro from "klaro"
import { klaroConfig } from "./src/klaro_config"

// Klaro global verfügbar machen, damit wir es im Stimulus Controller nutzen können
window.klaro = klaro
window.klaroConfig = klaroConfig

// Initialisierung starten
klaro.setup(window.klaroConfig)



